import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { LoadingService } from '../services/ui/loading.service';

@Injectable({
  providedIn: 'root',
})
export class AuthInterceptor implements HttpInterceptor {
  private activeRequests = 0;

  constructor(private injector: Injector, private loader: LoadingService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const token = localStorage.getItem('token');
    let agence: any = localStorage.getItem('agenceinso');
    agence = agence != null ? JSON.parse(agence) : {};
    
    request = request.clone({
      setParams: {
        lang: '' + localStorage.getItem('lang') + '',
        a: agence && agence.codeagence ? agence.codeagence : 'SVR',
      },
      headers: request.headers.set('Authorization', token ? token : ''),
    });

    const isSilent = request.url.includes('/assets/') || request.url.includes('i18n') || request.url.includes('ping') || request.url.includes('role') || request.headers.has('skip-loader');

    if (!isSilent) {
      if (this.activeRequests === 0) {
        this.loader.show();
      }
      this.activeRequests++;
    }

    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => event),
      catchError((error: HttpErrorResponse) => {
        if (error && error.status === 401) {
          // unauthorized
        }
        if (error && (error.status === 403 || error.error?.message === 'Session Closed')) {
          const translateService = this.injector.get(TranslateService);
          const title = translateService.instant('session_closed_title') || 'Session Closed';
          const text = translateService.instant('session_closed_text') || 'Your session has been closed. Please open a new session to continue.';
          import('sweetalert2').then(Swal => {
            Swal.default.fire(title, text, 'error').then(() => {
              localStorage.removeItem('session');
              window.location.href = '#/login';
            });
          });
        }
        return throwError(error);
      }),
      finalize(() => {
        if (!isSilent) {
          this.activeRequests--;
          if (this.activeRequests <= 0) {
            this.activeRequests = 0;
            this.loader.hide();
          }
        }
      })
    );
  }
}
